module.exports = __webpack_public_path__ + "static/img/Seat-filled.e018d2bf.png";